import { admin_cse, provider_case_manager, provider_peer } from "@/config/roles";
import { isAuthorized } from "@/redux/actions/auth";
import type { Provider } from "@/core/types";

export const canCreateAdvancedCareActivityNotes = (providerType: Provider) => {
  return (
    (isAuthorized("provider:behavioral") && providerType === "BEHAVIORAL") ||
    isAuthorized(admin_cse) ||
    isAuthorized("provider:prescribe") ||
    isAuthorized(provider_case_manager) ||
    isAuthorized(provider_peer)
  );
};
